import React from 'react';
import { Header } from './header/Header';
import styles from './layout.module.scss';

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className={styles.layout}>
      <Header />
      <main className={styles.layout__main}>
        {children}
      </main>
    </div>
  );
};
